const strings = {
  uk: {
    appName: 'Портал "ВО Свобода"',
    nav: 'Навігація',
    homePage: 'Головна',
    membership: 'Членство',
    organizations: 'Організації',
    signOut: 'Вихід',
    partyMembership: 'Партійне членство',
    officialName: 'Офіційна назва',
    shortName: 'Скорочена назва',
    placeholder: 'Скорочена назва організації ...',
    save: 'Зберегти',
    add: 'Додати',
    delete: 'Видалити',
    textForDeleteOrganization: 'Підтвердіть видалення організації',
    textForDeleteMember: 'Підтвердіть видалення партійного члена',
    textAfterDeleteOrganization: 'Організацію було видалено',
    textAfterDeleteMember: 'Партійного члена було видалено',
    close: 'Закрити',
    yes: 'Так',
    cardNumber: 'Посвідчення, №',
    firstName: 'Ім\'я',
    lastName: 'Прізвище',
    patronymic: 'По батькові',
    mobilePhoneNumber: 'Мобільний номер телефону',
    placeholderMember: 'Прізвище члена організації ...',
    nothingWasFound: 'Нічого не знайдено ...',
    walkOver: 'Перейти',
    back: 'Назад',
    successfulAddingOrganization: 'Організацію було додано',
    successfulEditOrganization: 'Організацію було змінено',
    successfulAddingMember: 'Партійного члена було додано',
    successfulEditMember: 'Партійного члена було змінено',
    control: 'Керування',
    error_1_11: 'Офіційна назва організації є занадто короткою',
    error_1_12: 'Офіційна назва організації є занадто довгою',
    error_1_13: 'Скорочена назва організації є занадто короткою',
    error_1_14: 'Скорочена назва організації є занадто довгою',
    error_1_15: 'Офіційна та скорочена назви організації є занадто різними',
    error_1_1: 'Організація є системоутворюючою, недоступною для змін',
    error_1_101: 'Організація містить дочірні структури',
    error_1_102: 'Організація містить членів партії',
    error_2_11: 'Номер посвідчення члена партії має невірний формат',
    error_2_12: 'Номер посвідчення члена партії належить іншому члену партії',
    error_2_13: 'Ім\'я члена партії є занадто коротким',
    error_2_14: 'Ім\'я члена партії є занадто довгим',
    error_2_15: 'Прізвище члена партії є занадто коротким',
    error_2_16: 'Прізвище члена партії є занадто довгим',
    error_2_17: 'По батькові члена партії є занадто коротким',
    error_2_18: 'По батькові члена партії є занадто довгим',
    error_2_19: 'Номер телефону члена партії має невірний формат',
    error_2_20: 'Номер телефону члена партії належить іншому члену партії',
    error_2_1: 'Член партії є системоутворюючим, недоступним для змін',
    unexpectedError: 'Неочікувана помилка, сконтактуйте з Юрієм Наумком, <a href="mailto:jurij@naumko.info">jurij@naumko.info</a>',
    documents: 'Документи',
    type: 'Тип файла',
    name: 'Назва документа',
    uploadFiles: 'Завантажити файл',
    document: 'Документ',
    notFile: 'не може бути пустим',
    error_3_22: 'Файл є невірного типу',
    error_3_11: 'Файл є порожній',
    error_4_11: 'Назва документа є занадто короткою',
    error_4_12: 'Назва документа є занадто довгою',
    nameDocument: 'Назва документа ...',
    successfulAddingDocument: 'Документ було додано',
    successfulEditDocument: 'Документ було змінено',
    textAfterDeleteDocument: 'Документ було видалено',
    addFile: 'Додати Файл',
    textForDeleteDocument: 'Підтвердіть видалення документа',
    download: 'Завантажити',
    textAfterFileUpload: 'Файл було завантажено',
    organization: 'Організація',
    partyOrganizationId: 'Необхідно вказати організацію',
    accessToForbiddenPage: 'Доступ до сторінки заборонено: недостатньо прав',
    testEnvTitle: 'тестове середовище'
  }
}

export default strings



// WEBPACK FOOTER //
// ./src/lang/index.js